module.exports = __webpack_public_path__ + "img/kt-websitebanner.526d065c.jpg";